import defaultColor from "@/components/color";
export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0,
        dataText:'[{"name":"南海诸岛","value":0},{"name":"北京","value":54},{"name":"天津","value":13},{"name":"上海","value":40},{"name":"重庆","value":75},{"name":"河北","value":13},{"name":"河南","value":83},{"name":"云南","value":11},{"name":"辽宁","value":19},{"name":"黑龙江","value":15},{"name":"湖南","value":69},{"name":"安徽","value":60},{"name":"山东","value":39},{"name":"新疆","value":4},{"name":"江苏","value":31},{"name":"浙江","value":104},{"name":"江西","value":36},{"name":"湖北","value":1052},{"name":"广西","value":33},{"name":"甘肃","value":7},{"name":"山西","value":9},{"name":"内蒙古","value":7},{"name":"陕西","value":22},{"name":"吉林","value":4},{"name":"福建","value":18},{"name":"贵州","value":5},{"name":"广东","value":98},{"name":"青海","value":1},{"name":"西藏","value":0},{"name":"四川","value":44},{"name":"宁夏","value":4},{"name":"海南","value":22},{"name":"台湾","value":3},{"name":"香港","value":5},{"name":"澳门","value":5}]',
    },
    attribute:{
        roam:false,titleText:'肺炎地图',titleLeft: 'center', titleTop: 'top',
        subtext:'数据纯属虚构',titleFontSize:18,titleColor: '#CCC',
        subTitleColor:'#aaa',subTitleFontSize:13,
        tipFormatter:'确诊病例<br/>${name}：${value}',geoLabelColor:'#555',geoLabelSize:10,borderColor:'#666',
        visualMap: {
            show: true,
            min: 0,
            max: 100,
            left: 20,
            top: 'bottom',
            text: ["高", "低"],
            textStyle: {
                color: '#ddd'
            },
            pieces: [{
                gte: 100,
                label: '> 100 人'
            }, {
                gte: 10,
                lt: 100,
                label: '10 - 100 人'
            }, {
                gte: 1,
                lt: 10,
                label: '1 - 9 人'
            }, {
                gte: 0,
                lt: 1,
                label: '无'
            }],
        },
        provinceCode:'china',cityCode:'',enableDrillDown:false,
        color:defaultColor,areaColor:'#988205',
        cptTableData: [{ "name": "维度", "value": "", "namekey": "name" },{ "name": "指标", "value": "", "namekey": "value" }] 
    },
}
